import * as React from 'react';
import { FieldRenderProps } from 'react-final-form';
import { Field } from '../form/Field';
import { VFFilterFieldProps } from '../form/types';
import { FilterItem } from './FilterItem';
import { FilterFieldProps, getFilterFieldFormValuePath } from './types';
import { SelectBox } from '../selectbox/SelectBox';
import { DATA_FILTER_INPUT } from '../common/data';

export type NumberProps = VFFilterFieldProps<
  React.ComponentProps<typeof SelectBox> & FilterFieldProps
>;
export const FilterSelectBox = React.forwardRef<HTMLInputElement, NumberProps>(
  (
    {
      name,
      validate,
      className,
      inputClassName,
      label,
      required,
      disabled,
      size = 6,
      filterType,
      extendedFilter,
      ...other
    },
    ref
  ) => {
    return (
      <FilterItem
        name={name}
        className={className}
        label={label}
        disabled={disabled}
        filterType={filterType}
        extendedFilter={extendedFilter}
      >
        <Field
          name={getFilterFieldFormValuePath(name, filterType)}
          validate={validate}
        >
          {({
            input: { value, onChange, onBlur, name, ...nother },
            meta,
          }: FieldRenderProps<number>) => {
            return (
              <SelectBox
                {...DATA_FILTER_INPUT(name)}
                className={inputClassName}
                size={size}
                // @ts-ignore
                ref={ref}
                {...nother}
                // @ts-ignore
                name={name}
                {...other}
                useIdAsValue
                disabled={disabled || meta.submitting}
                value={value}
                onChange={(newValue: any) => {
                  onChange({ target: { name, value: newValue } });
                }}
              />
            );
          }}
        </Field>
      </FilterItem>
    );
  }
);
